/**
 * Extracts the numeric event id from an enterprise URL when the user is on
 * an event-specific page. Returns `undefined` for non-event routes
 * (`/dashboard/home`, `/dashboard/organization/*`) or when the path doesn't
 * contain a parseable id.
 *
 * Recognized event-specific shapes:
 *   /dashboard/home/[event_id]
 *   /dashboard/source/[event_id]/...
 *   /dashboard/manage/[event_id]/...
 *
 * @param pathname - The current `window.location.pathname` or Next.js `usePathname()`.
 * @returns The event id as a number, or `undefined` if not on an event page.
 */
export const extractEventIdFromPath = (pathname: string): number | undefined => {
  const parts = pathname.split("/").filter(Boolean);
  if (parts[0] !== "dashboard") return undefined;
  const section = parts[1];
  if (section !== "home" && section !== "source" && section !== "manage") return undefined;
  const id = parts[2];
  // Strict positive-integer match — reject "123abc", "-1", "0x1f", etc. Backend
  // authorizes by JWT, so this is defensive only.
  if (!id || !/^\d+$/.test(id)) return undefined;
  return parseInt(id, 10);
};
